import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONVERSATION_MODES } from '../../../constants/modes';
import { useAIChatConversation } from '../../../contexts/AIChatConversation/useAIChatConversation';
import ChatButton from '../ChatButton';
import './ChatHeader.scss';

function ChatHeader({ onClose, onCollapse, onToggleHistory, onNewChat, historyButtonRef, showHistory = false, showLeftContent = true }) {
  const { t } = useTranslation(['chatbot']);
  const { mode } = useAIChatConversation();

  // Use onCollapse if provided, otherwise fall back to onClose
  const handleCloseClick = onCollapse || onClose;

  return (
    <div className="chat-header-container">
      <div className="chat-header">
        <div className="chat-header__left">
          {showLeftContent && mode === CONVERSATION_MODES.STUDY && (
            <>
              <ChatButton
                variant="text"
                color="brand"
                onClick={onNewChat}
                icon="new"
                iconPosition="left"
                className="chat-header__new-chat-button"
                title={t('chatbot:New chat')}
              >
                {t('chatbot:New chat')}
              </ChatButton>
              <span className="chat-header__divider" aria-hidden="true" />
              <ChatButton
                ref={historyButtonRef}
                variant="text"
                color="brand"
                onClick={onToggleHistory}
                icon="conversation"
                iconPosition="left"
                isActive={showHistory}
                className={classNames('chat-header__history-button', { 'chat-header__history-button--active': showHistory })}
                title={t('chatbot:Recents')}
                aria-expanded={showHistory}
              >
                {t('chatbot:Recents')}
              </ChatButton>
            </>
          )}
        </div>

        <div className="chat-header__center">{/* Center badge removed */}</div>

        <div className="chat-header__right">
          {(mode === CONVERSATION_MODES.STUDY || mode === CONVERSATION_MODES.PRACTICE || mode === CONVERSATION_MODES.TEACHER_TOOLS || mode === CONVERSATION_MODES.REVISION) && (
            <ChatButton
              variant="outlined"
              color="brand"
              onClick={handleCloseClick}
              icon="close"
              iconPosition="iconOnly"
              className="chat-header__close-button"
              title={onCollapse ? t('chatbot:Collapse') : t('chatbot:Close')}
            />
          )}
        </div>
      </div>
    </div>
  );
}

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onCollapse: PropTypes.func,
  onNewChat: PropTypes.func,
  onToggleHistory: PropTypes.func,
  showHistory: PropTypes.bool,
  historyButtonRef: PropTypes.object,
  showLeftContent: PropTypes.bool,
};

ChatHeader.defaultProps = {
  onClose: () => {},
  onNewChat: () => {},
  onToggleHistory: () => {},
  showHistory: false,
  historyButtonRef: null,
  showLeftContent: true,
};

export default ChatHeader;
